<template>
    <b-modal v-model="modal.ver"
             title="Caracterización del riesgo"
             centered
             hide-footer
    >
        <table v-if="isInhalation"
               class="table table-striped table-bordered table-hover table-sm"
        >
            <tbody>
            <tr>
                <td class="font-weight-bold w-75">TLV [mg/m3] Modificado</td>
                <td class="text-center">{{ resultado.tlv }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Clase de cantidad</td>
                <td class="text-center">{{ resultado.clase_cantidad }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Clase de frecuencia</td>
                <td class="text-center">{{ resultado.clase_frecuencia }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Clase de peligro</td>
                <td class="text-center">{{ resultado.id_clase_peligro }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Clase exposición potencial</td>
                <td class="text-center">{{ resultado.clase_exposicion_potencial }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Clase riesgo potencial</td>
                <td class="text-center">{{ resultado.clase_riesgo_potencial }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación riesgo potencial</td>
                <td class="text-center">{{ resultado.puntuacion_riesgo_potencial }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación Volatilidad / Pulverulencia</td>
                <td class="text-center">{{ resultado.puntuacion_pulverulencia }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación de procedimiento</td>
                <td class="text-center">{{ resultado.puntuacion_procedimiento_colectivo }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación protección colectiva</td>
                <td class="text-center">{{ resultado.factor_conversion_tlv }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Factor conversión TLV</td>
                <td class="text-center">{{ resultado.factor_conversion_tlv }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación Inhalación</td>
                <td class="text-center">{{ resultado.puntuacion_riesgo }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75"> Prioridad de acción</td>
                <td class="text-center">{{ resultado.caracterizacion_riesgo.prioridad }}</td>
            </tr>
            <tr :class="claseCaracterizacion()">
                <td colspan="2"
                    class="text-center font-weight-bold"
                >
                    {{ resultado.caracterizacion_riesgo.caracterizacion }}
                </td>
            </tr>
            </tbody>
        </table>
        <table v-else
               class="table table-striped table-bordered table-hover table-sm"
        >
            <tbody>
            <tr>
                <td class="font-weight-bold w-75">TLV [mg/m3] Modificado</td>
                <td class="text-center">{{ resultado.tlv }}</td>
            </tr>

            <tr>
                <td class="font-weight-bold w-75">Frecuencia de exposición</td>
                <td class="text-center">{{ resultado.frecuencia_exposicion }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Clase de peligro</td>
                <td class="text-center">{{ resultado.id_clase_peligro }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación de peligro</td>
                <td class="text-center">{{ resultado.puntuacion_peligro }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación de superficie</td>
                <td class="text-center">{{ resultado.puntuacion_superficie }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación de frecuencia</td>
                <td class="text-center">{{ resultado.puntuacion_frecuencia }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75">Puntuación Dérmico</td>
                <td class="text-center">{{ resultado.puntuacion_riesgo }}</td>
            </tr>
            <tr>
                <td class="font-weight-bold w-75"> Prioridad de acción</td>
                <td class="text-center">{{ resultado.caracterizacion_riesgo.prioridad }}</td>
            </tr>
            <tr :class="claseCaracterizacion()">
                <td colspan="2"
                    class="text-center font-weight-bold"
                >
                    {{ resultado.caracterizacion_riesgo.caracterizacion }}
                </td>
            </tr>
            </tbody>
        </table>
    </b-modal>
</template>

<script>

import {mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('analysis', ['modal', 'resultado', 'vias_ingreso', 'tarea']),
        isInhalation(){
            let via_ingreso = this.vias_ingreso.find(vi => vi.id === this.tarea.id_via_ingreso)

            return via_ingreso && via_ingreso.codigo === 'VING01';
        }
    },
    methods: {
        claseCaracterizacion() {
            if (this.resultado.caracterizacion_riesgo.prioridad === 1) {
                return 'table-danger';
            } else if (this.resultado.caracterizacion_riesgo.prioridad === 2) {
                return 'table-warning';
            }

            return 'table-success';
        }
    }
};
</script>

<style scoped>

</style>
